module.exports = __webpack_public_path__ + "img/chinesecompany115.6ddfe5f0.png";